import localforage from "localforage";

self.addEventListener('sync', event => {
    console.log('[SW] Syncing', event);
    event.waitUntil(syncSW(event));
});

/**
 * @function syncSW
 * Executes a list of offline tasks when the service worker detects connectivity is back
 **/
async function syncSW(event) {
    // This function handles a sync task - offlineSurveyStore
    if (event.tag === 'offlineSurveyStore') {
        const tasks = [];

        // Configuring localforage to use offlineSurveyStore database
        localforage.config({
            name: 'offlineSurveyStore'
        });

        // Looping through all tasks in the offlineSurveyStore database
        localforage.iterate(function (value, key, iterationNumber) {
            tasks.push(fetch(value.endpoint, value.options));
        }).then(function (data) {
            Promise.all(tasks)
                .then(function (data) {
                    console.log('[SW] Offline tasks sync succeeded.', data);
                    // Put Push Notification script here

                    // CLear the database
                    localforage.clear();
                }).catch(function (err) {
                console.error('[SW] Offline tasks sync failed:', err);
            });
        }).catch(function (err) {
            console.error('[SW] Iterate through offline tasks failed:', err);
        });
    }
}

